import { Col, Form, Row } from "react-bootstrap";

export interface FacilityOperationRegDataComparisonRowProps {
    mode: "display" | "edit";
    editedValue?: Record<string, unknown>;
    onChange?: (editedValue: Record<string, unknown>) => void;
    displayCode?: string;
    displayDescription?: string;
}

export function FacilityOperationRegDataComparisonRow({
    mode,
    editedValue,
    onChange,
    displayCode,
    displayDescription,
}: FacilityOperationRegDataComparisonRowProps) {
    if (mode === "display") {
        return (
            <div className="small">
                <span>{displayCode?.trim() ? displayCode : "—"}</span>
                <span className="mx-1">|</span>
                <span>{displayDescription ?? ""}</span>
            </div>
        );
    }

    const code = String(editedValue?.code ?? "");
    const description = String(editedValue?.description ?? "");

    return (
        <Row className="g-2 small">
            <Col md={4}>
                <Form.Group>
                    <Form.Label className="mb-0">Code (optional)</Form.Label>
                    <Form.Control
                        size="sm"
                        value={code}
                        onChange={(e) => onChange?.({ ...editedValue, code: e.target.value })}
                    />
                </Form.Group>
            </Col>
            <Col md={8}>
                <Form.Group>
                    <Form.Label className="mb-0">Description</Form.Label>
                    <Form.Control
                        size="sm"
                        value={description}
                        onChange={(e) => onChange?.({ ...editedValue, description: e.target.value })}
                    />
                </Form.Group>
            </Col>
        </Row>
    );
}
